import { Reducer, Action } from "redux"
import { DocumentExtraction } from "universal-schema/lib/1.0.0/document-schema"

import { VisualEditorType, AuthUserType } from "../../Actions/Types"
import { APIAppTemplateSchemaModel } from "../../Models/API/AppTemplateModel"
import { FetchState } from "../../Models/Client/FetchState"
import { Result } from "../../Models/Utility/Result"
import { AuthAction } from "../Auth"
import { APIAuthenticationAction } from "./AuthenticationReducer"

export type VisualEditorState = {
    detectingAnnotations?: boolean
    detectedAnnotations?: DocumentExtraction
    appSchema?: FetchState<APIAppTemplateSchemaModel>
} | null

interface DetectAnnotations
    extends Action<VisualEditorType.detectAnnotations> {}

interface ReceivedDetectedAnnotations
    extends Action<VisualEditorType.receivedDetectedAnnotations> {
    payload?: DocumentExtraction
}

interface ReceivedDetectionErrors
    extends Action<VisualEditorType.receivedDetectionErrors> {}

interface GetAppSchema extends Action<VisualEditorType.getAppSchema> {}

interface SetAppSchema extends Action<VisualEditorType.setAppSchema> {
    payload: APIAppTemplateSchemaModel
}

interface SetAppSchemaErrors
    extends Action<VisualEditorType.setAppSchemaErrors> {
    payload: string
}

export type VisualEditorAction =
    | DetectAnnotations
    | ReceivedDetectedAnnotations
    | ReceivedDetectionErrors
    | GetAppSchema
    | SetAppSchema
    | SetAppSchemaErrors

const initialState: VisualEditorState = {
    appSchema: undefined
}

export const VisualEditorReducer: Reducer<
    VisualEditorState,
    VisualEditorAction | AuthAction | APIAuthenticationAction
> = (state = initialState, action): VisualEditorState => {
    switch (action.type) {
        case VisualEditorType.detectAnnotations:
            return state === null
                ? null
                : {
                      ...state,
                      detectingAnnotations: true
                  }
        case VisualEditorType.receivedDetectedAnnotations:
            return state === null
                ? null
                : {
                      ...state,
                      detectingAnnotations: false,
                      detectedAnnotations: action.payload
                  }
        case VisualEditorType.receivedDetectionErrors:
            return state === null
                ? null
                : {
                      ...state,
                      detectingAnnotations: false
                  }
        case VisualEditorType.getAppSchema:
            return state === null
                ? null
                : {
                      ...state,
                      appSchema: "loading"
                  }
        case VisualEditorType.setAppSchema:
            return state === null
                ? null
                : {
                      ...state,
                      appSchema: Result.ok(action.payload)
                  }
        case VisualEditorType.setAppSchemaErrors:
            return state === null
                ? null
                : {
                      ...state,
                      appSchema: Result.error(action.payload)
                  }
        case AuthUserType.signedOut:
            return null
        default:
            return state
    }
}
